/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkshopProblemRead } from './WorkshopProblemRead';
import {
    WorkshopProblemReadFromJSON,
    WorkshopProblemReadFromJSONTyped,
    WorkshopProblemReadToJSON,
    WorkshopProblemReadToJSONTyped,
} from './WorkshopProblemRead';

/**
 * Schema for workshop with its problems.
 * @export
 * @interface WorkshopWithProblems
 */
export interface WorkshopWithProblems {
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    topic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    mentor_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    class_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopWithProblems
     */
    created_at?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof WorkshopWithProblems
     */
    is_active?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopWithProblems
     */
    start_time: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopWithProblems
     */
    end_time: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    series_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    mentor_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopWithProblems
     */
    class_name?: string | null;
    /**
     * 
     * @type {Array<WorkshopProblemRead>}
     * @memberof WorkshopWithProblems
     */
    problems?: Array<WorkshopProblemRead>;
}

/**
 * Check if a given object implements the WorkshopWithProblems interface.
 */
export function instanceOfWorkshopWithProblems(value: object): value is WorkshopWithProblems {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mentor_id' in value) || value['mentor_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('start_time' in value) || value['start_time'] === undefined) return false;
    if (!('end_time' in value) || value['end_time'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function WorkshopWithProblemsFromJSON(json: any): WorkshopWithProblems {
    return WorkshopWithProblemsFromJSONTyped(json, false);
}

export function WorkshopWithProblemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopWithProblems {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'topic': json['topic'] == null ? undefined : json['topic'],
        'description': json['description'] == null ? undefined : json['description'],
        'mentor_id': json['mentor_id'],
        'organization_id': json['organization_id'],
        'class_id': json['class_id'] == null ? undefined : json['class_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'start_time': (new Date(json['start_time'])),
        'end_time': (new Date(json['end_time'])),
        'series_id': json['series_id'] == null ? undefined : json['series_id'],
        'id': json['id'],
        'mentor_name': json['mentor_name'] == null ? undefined : json['mentor_name'],
        'class_name': json['class_name'] == null ? undefined : json['class_name'],
        'problems': json['problems'] == null ? undefined : ((json['problems'] as Array<any>).map(WorkshopProblemReadFromJSON)),
    };
}

export function WorkshopWithProblemsToJSON(json: any): WorkshopWithProblems {
    return WorkshopWithProblemsToJSONTyped(json, false);
}

export function WorkshopWithProblemsToJSONTyped(value?: WorkshopWithProblems | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'topic': value['topic'],
        'description': value['description'],
        'mentor_id': value['mentor_id'],
        'organization_id': value['organization_id'],
        'class_id': value['class_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'is_active': value['is_active'],
        'start_time': ((value['start_time']).toISOString()),
        'end_time': ((value['end_time']).toISOString()),
        'series_id': value['series_id'],
        'id': value['id'],
        'mentor_name': value['mentor_name'],
        'class_name': value['class_name'],
        'problems': value['problems'] == null ? undefined : ((value['problems'] as Array<any>).map(WorkshopProblemReadToJSON)),
    };
}

